import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import SelectCst from "@components/InputCst/SelectCst";
import { FieldGrid } from "./StepLayout";
import { useSkillOptions } from "../useSkillOptions";

export interface MestieriValue {
  industry: number | null;
  profession: number | null;
  job: number | null;
}

interface MestieriSectionProps {
  corporateId: string;
  title: string;
  labels: { industrial: string; professional: string; job: string };
  value: MestieriValue;
  onChange: (patch: Partial<MestieriValue>) => void;
}

const toNum = (v: any): number | null =>
  v === "" || v === null || v === undefined ? null : Number(v);

const MestieriSection: React.FC<MestieriSectionProps> = ({
  corporateId,
  title,
  labels,
  value,
  onChange,
}) => {
  const theme = useTheme();
  const { industries, professions, jobs } = useSkillOptions(
    corporateId,
    value.industry,
    value.profession,
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 700,
          color: theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>
      <FieldGrid>
        <SelectCst
          id="mestieri-industry"
          label={labels.industrial}
          value={value.industry ?? ""}
          options={industries}
          onChange={(v: any) =>
            onChange({ industry: toNum(v), profession: null, job: null })
          }
        />
        <SelectCst
          id="mestieri-profession"
          label={labels.professional}
          value={value.profession ?? ""}
          options={professions}
          disabled={!value.industry}
          onChange={(v: any) => onChange({ profession: toNum(v), job: null })}
        />
        <SelectCst
          id="mestieri-job"
          label={labels.job}
          value={value.job ?? ""}
          options={jobs}
          disabled={!value.profession}
          onChange={(v: any) => onChange({ job: toNum(v) })}
        />
      </FieldGrid>
    </Box>
  );
};

export default MestieriSection;
